import { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { saveUserSession } from '../../redux/actions/userActions';
import { auth } from '../../firebase';

const useAuthListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      dispatch(saveUserSession(currentUser || null));
    });

    return () => unsubscribe();
  }, [dispatch]);
};

export default useAuthListener;